// Module
var code = `<inline-panel on-hide="\$ctrl.onHide()">

  <div class="inline-panel__container" ng-repeat="item in \$ctrl.pdcPropertiesMap">
    <label class="inline-panel__label">{{item.key}}:</label>
    <p class="inline-panel__value">{{item.value}}</p>
  </div>

  <div class="inline-panel-footer"
    ng-if="\$ctrl.loan.status != 'INACTIVE' && \$ctrl.loan.status != 'PENDING'">
    <button
      command-access="UpdateLoanPDC"
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.edit()"
      ng-disabled="!\$ctrl.canBeCanceled()">
      Edit
    </button>
    <button
      command-access="RemoveLoanPDC"
      type="button"
      class="btn btn-danger"
      ng-click="\$ctrl.remove()"
      ng-disabled="!\$ctrl.canBeCanceled()">
      Remove
    </button>
    <button
      command-access="CancelLoanPDC"
      type="button"
      class="btn btn-danger"
      ng-click="\$ctrl.cancel()"
      ng-disabled="!\$ctrl.canBeCanceled()">
      Cancel
    </button>
    <button
      command-access="EncashLoanPDC"
      type="button"
      class="btn btn-success"
      ng-click="\$ctrl.post()"
      ng-disabled="!\$ctrl.canBePosted()">
      Post
    </button>
    <button
      command-access="PostponeLoanPDC"
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.postpone()"
      ng-disabled="!\$ctrl.canBePostponed()">
      Postpone
    </button>
  </div>
</inline-panel>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/pdc/tab/details/loan-pdc-tab-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;